import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { StatusService } from '@services/v2/status.service';
import { Observable } from 'rxjs';
import { LoginService } from '../_services/login.service';
import { OrderOnBehalfService } from '../_services/order-on-behalf.service';

const skipAuthHeaderUrlParts = ['/assets/', 'dcgcontent', 'customiser-images'];

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
	if (skipAuthHeaderUrlParts.some(part => req.url.includes(part))) {
		return next(req);
	}

	const loginService = inject(LoginService);
	const orderOnBehalfService = inject(OrderOnBehalfService);
	const versionService = inject(StatusService);

	const headers: { [name: string]: string | string[] } = {};

	const appVersion = versionService.getApiVersion();
	headers["appVersion"] = appVersion;

	const accessToken = loginService.GetToken();

	if (accessToken) {
		headers['Authorization'] = `Bearer ${accessToken}`;
	}

	const customer = orderOnBehalfService.customerSnapshot();

	if (customer?.Token) {
		headers['customer'] = customer.Token;
	}

	req = req.clone({
		setHeaders: headers
	});

	return next(req);
};